import { SelectOptionProps } from '@acceso/design-system';
import { useMemo } from 'react';

import { useUsers } from '../api/get-users';
import { User } from '../types/types';
import { getUserFullName } from '../utils/getUserFullName';

type useUserOptionsProps = {
  usersIds: string[];
};

export function useUserOptions(
  { usersIds }: useUserOptionsProps = { usersIds: [] }
): SelectOptionProps<string>[] {
  const { data: users = [] } = useUsers();

  const usersToConvert = useMemo(
    () =>
      usersIds.length > 0
        ? (usersIds.map(id => users.find(user => user.id === id)).filter(Boolean) as User[])
        : users,
    [users, usersIds]
  );

  const options: SelectOptionProps<string>[] = usersToConvert.map(user => ({
    label: getUserFullName(user),
    value: user.id,
  }));

  return options;
}
